/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/style-prop-object */
/* eslint-disable react/prop-types */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { AiFillCloseCircle, AiOutlineMinusCircle, AiOutlinePlusCircle } from "react-icons/ai";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { FaSort } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";

import ScrollContainer from "react-indiana-drag-scroll";
import { useDispatch, useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import Popup from "reactjs-popup";
import MechanicsSummary from "../../../components/Cartesian/MechanicsSummary/MechanicsSummary";
import ComparatorLine from "../../../components/Retrofit/Devices/BundleComparator/ComparatorLine";
import Button from "../../../components/common/Buttons/Button/Button";
import MsxIcons from "../../../components/common/Icons/MsxIcons/MsxIcons";
import {
  addAxisToCompare,
  resetAxesToCompare,
  selectAxesCombinations,
  selectAxesToCompare,
  selectAxisSelection,
  selectCartesianFilters,
  selectCartesianReadOnlyMode,
  selectCartesianSteps,
  selectDynamics,
  selectMechanics,
  selectSelectedAxis,
  setAxesCombinations,
  setAxesToCompare,
  setAxisOptions,
  setAxisSelection,
  setCartesianCurrentStep,
  setSelectedAxis
} from "../../../store/slices/cartesian";
import t, { tr } from "../../../utils/common/translation/translator";
import "./AxisSelection.scss";
import AxisSelectionFilter from "./AxisSelectionFilter";
import TableSkeleton from "../../../components/Retrofit/Devices/CorrespondingCrossComponent/TableSkeleton";
import Pagination from "../../../components/common/Pagination/Pagination";
import { DEFAULT_AXIS_OPTIONS } from "../../../store/data/cartesianData";
import { updateConfiguration } from "../../../store/slices/common";
import { getProductImgUrl } from "../../../utils/common/api/api";
import { useQuery } from "react-query";
import { getAxesCombinations } from "../../../utils/api/Cartesian/api";

import Navigator from "../../../layouts/Navigator/Navigator";
import { showSnackbar } from "../../../store/slices/retrofit";

const TOO_WEAK = t("cartesian.ui.axis_selection.too_weak");
const PERFECT = t("cartesian.ui.axis_selection.perfect");
const TOO_BIG = t("cartesian.ui.axis_selection.too_big");

const ProductTableHeaders = [
  { name: t("cartesian.ui.axis_selection.guide_type"), sort: false, valuePath: "guideType.guideType" },
  {
    name: t("cartesian.ui.axis_selection.carriage_type"),
    sort: false,
    valuePath: "carriageType.typeOfCarriage"
  },
  {
    name: t("cartesian.ui.axis_selection.feed_constant"),
    sort: false,
    unit: "mm/rev",
    valuePath: "axis.feedConstant"
  }
];

const TechnicalFeaturesTableHeaders = [
  {
    name: t("cartesian.ui.axis_selection.mechanical_drive_element"),
    sort: false,
    valuePath: "axis.driveType"
  },
  {
    name: t("cartesian.ui.axis_selection.repeatability"),
    sort: false,
    unit: "±",
    valuePath: "axis.repeatability"
  },
  {
    name: t("cartesian.ui.axis_selection.axis_profile"),
    sort: false,
    subHeaders: [
      { name: t("cartesian.ui.axis_selection.width"), unit: "mm", valuePath: "axisProfile.width" },
      { name: t("cartesian.ui.axis_selection.height"), unit: "mm", valuePath: "axisProfile.height" }
    ]
  },
  {
    name: t("cartesian.ui.dynamics.carriage"),
    sort: false,
    subHeaders: [
      {
        name: t("cartesian.ui.axis_selection.length"),
        unit: "mm",
        valuePath: "carriageType.lenghtCommercialReference"
      },
      {
        name: t("cartesian.ui.axis_selection.weight"),
        unit: "kg",
        valuePath:
          "data.coverstrip?calculations.totalAxisWeightPreCalculations.preCalcWeightCarriageWcoverstrip:calculations.totalAxisWeightPreCalculations.preCalcWeightCarriageWoCoverstrip"
      }
    ]
  },
  {
    name: t("cartesian.ui.axis_selection.total_axis"),
    sort: false,
    subHeaders: [
      {
        name: t("cartesian.ui.axis_selection.length"),
        unit: "mm",
        valuePath: "calculations.axisLength"
      },
      {
        name: t("cartesian.ui.axis_selection.weight"),
        unit: "kg",
        valuePath: "calculations.axisWeight"
      }
    ]
  }
];

const PerformanceOverviewTableHeaders = [
  {
    name: t("cartesian.ui.axis_selection.utilization_mechanical_drive_torque"),
    sort: false,
    unit: "%",
    valuePath: "calculations.driveTorqueUtilization"
  },
  {
    name: t("cartesian.ui.axis_selection.utilization_speed"),
    sort: false,
    unit: "%",
    valuePath: "calculations.speedAxisUtilization"
  }
];

const GuidingSystemTableHeaders = (numberOfCarriage) => {
  const GuidingSystemTableHeaders = [];
  for (let i = 0; i < numberOfCarriage; i++) {
    GuidingSystemTableHeaders.push({
      name: t("cartesian.ui.dynamics.carriage") + " " + (i + 1),
      sort: false,
      valuePath: "",
      subHeaders: [
        {
          name: t("cartesian.ui.axis_selection.utilization"),
          unit: "%",
          valuePath: "calculations.precalcKFactorCarriage[" + i + "]"
        },
        {
          name: t("cartesian.ui.axis_selection.service_life"),
          unit: t("cartesian.ui.axis_selection.years"),
          valuePath: "calculations.serviceLifeYearsCarriage[" + i + "]"
        }
      ]
    });
  }
  return GuidingSystemTableHeaders;
};

const getCollapsableHeaderContent = (length) => {
  const content = [];
  for (let i = 0; i < length - 1; i++) {
    content.push(
      <th className="px-0">
        <div className="flex items-center">
          <span className="text-sm invisible-element w-0">a</span>
          <hr className="bg-gray-500 h-0.1 flex-1" />
          {i === length - 2 && <span className="bg-gray-500 w-0.1 h-3" />}
        </div>
      </th>
    );
  }
  return content;
};

const TableCollapsableHeaders = ({ title, length, updateFunction, defaultValue, expand, expandFunction }) => {
  return (
    <>
      <th className="TableCollapsableHeaders font-normal text-left pl-3 pr-0 text-gray-600" key="product-0-header">
        <div className="flex items-center">
          <span className="text-sm whitespace-nowrap">{title}</span>
          <span className="mx-2 flex items-center">
            {expand && (
              <AiOutlineMinusCircle
                className="text-sm cursor-pointer"
                onClick={() => {
                  updateFunction(1);
                  expandFunction(false);
                }}
              />
            )}
            {!expand && (
              <AiOutlinePlusCircle
                className="text-sm cursor-pointer"
                onClick={() => {
                  updateFunction(defaultValue);
                  expandFunction(true);
                }}
              />
            )}
          </span>
          {!expand && <BiDotsHorizontalRounded className="text-xs text-gray-600" />}
          <hr className="bg-gray-400 h-0.1 flex-1" />
        </div>
      </th>
      {getCollapsableHeaderContent(length)}
    </>
  );
};

const TableHeader = ({ title, colNumber, isSort, hasUnitHeader, subHeaders, unit }) => {
  const mechanics = useSelector(selectMechanics);

  const TableHeaders = [
    { name: t("cartesian.ui.axis_selection.product"), sort: true },
    ...ProductTableHeaders,
    ...TechnicalFeaturesTableHeaders,
    ...PerformanceOverviewTableHeaders,
    ...GuidingSystemTableHeaders(mechanics.quantityCarriages),
    { name: t("cartesian.ui.axis_selection.select"), sort: false }
  ];

  return (
    <th
      className={`TableHeader border-[1px] border-solid border-x-[0.5px] border-gray-200 bg-gray-100 p-0 ${
        colNumber === 0 ? "sticky left-0 z-10" : ""
      } ${colNumber === TableHeaders.length - 1 ? "sticky right-0 z-10" : ""}`}
    >
      <div className="flex flex-col justify-between h-full min-h-[80px] divide-y divide-gray-300">
        <div className="flex items-center space-x-2 text-xs font-semibold py-1 px-4 flex-grow">
          <span className="whitespace-nowrap m-auto">{title}</span>
          {isSort && <FaSort className="cursor-pointer text-gray-500 text-base" />}
        </div>
        {subHeaders && subHeaders.length > 0 ? (
          <>
            <div className="flex divide-x divide-gray-300">
              {subHeaders.map((subHeader, index) => (
                <div key={index} className="flex-1 px-4">
                  <span className="text-xs font-normal py-1">{subHeader.name}</span>
                </div>
              ))}
            </div>
            <div className="flex items-center space-x-2 font-normal text-xs py-1 bg-gray-300">
              {subHeaders.map((subHeader, index) => (
                <div key={`unit-${index}`} className="flex-1 px-4">
                  <span className="text-xs font-normal py-1">{subHeader.unit || "-"}</span>
                </div>
              ))}
            </div>
          </>
        ) : (
          hasUnitHeader && (
            <div className="flex items-center space-x-2 font-normal text-xs py-1 px-4 bg-gray-300 border-b border-gray-200">
              <span className="whitespace-nowrap">{unit || "-"}</span>
            </div>
          )
        )}
      </div>
    </th>
  );
};

const AxisPerformance = ({ position }) => {
  let classPosition = "items-center justify-center";

  if (position === t("cartesian.ui.axis_selection.too_weak")) {
    classPosition = "items-start justify-start";
  }

  if (position === t("cartesian.ui.axis_selection.too_big")) {
    classPosition = "items-end justify-end";
  }

  return (
    <div className="AxisPerformance flex flex-col">
      <div className="flex flex-row justify-between text-xxs">
        <div
          className={`flex items-start  ${
            position === t("cartesian.ui.axis_selection.too_weak") ? "font-bold" : "font-light text-gray-500"
          }`}
        >
          {t("cartesian.ui.axis_selection.too_weak")}
        </div>
        <div className={`flex items-center px-3 ${position === PERFECT ? "font-bold" : "font-light text-gray-500"}`}>
          {t("cartesian.ui.axis_selection.perfect")}
        </div>
        <div className={`flex items-end ${position === TOO_BIG ? "font-bold" : "font-light text-gray-500"}`}>
          {t("cartesian.ui.axis_selection.too_big")}
        </div>
      </div>
      <div className="flex rounded-[25px] h-[7px] w-full bg-[#CBCBCB]" />
      <div style={{ margin: "-1px" }} className={`flex ${classPosition}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="11" viewBox="-1 0 25 11" fill="none">
          <path d="M12.5 0L24.1913 10.5H0.808657L12.5 0Z" fill="#42B4E6" />
        </svg>
      </div>
    </div>
  );
};

const ProgressBar = ({ percentage }) => {
  const greenColor = "#008a16";
  const yellowColor = "#FFD100";
  const redColor = "#DC0A0A";
  let stopColor = percentage <= 80 ? greenColor : yellowColor;
  stopColor = percentage > 100 ? redColor : stopColor;

  const fillerStyles = {
    width: `${percentage}%`,
    backgroundColor: stopColor,
    borderRadius: "inherit"
  };

  return (
    <div className="ProgressBar flex flex-col ">
      <div className="flex items-start text-xs" style={{ color: stopColor }}>
        {percentage}%
      </div>
      <div className="flex rounded-[25px] h-[7px] w-full bg-[#E6E7EB]">
        <div style={fillerStyles} />
      </div>
    </div>
  );
};

const TableCollapsableHeadersSection = ({
  productLength,
  setProductLength,
  productExpand,
  setProductExpand,
  technicalFeatureLength,
  setTechnicalFeatureLength,
  technicalFeatureExpand,
  setTechnicalFeatureExpand,
  performanceOverviewLength,
  setPerformanceOverviewLength,
  performanceOverviewExpand,
  setPerformanceOverviewExpand,
  guidingSystemLength,
  setGuidingSystemLength,
  guidingSystemExpand,
  setGuidingSystemExpand
}) => {
  const mechanics = useSelector(selectMechanics);
  return (
    <tr className="TableCollapsableHeadersSection">
      <th className="main py-3 px-1 text-transparent">.</th>
      <TableCollapsableHeaders
        data-testid="table-collapsable-headers-product"
        title={t("cartesian.ui.axis_selection.product")}
        length={productLength}
        updateFunction={setProductLength}
        defaultValue={ProductTableHeaders.length}
        expand={productExpand}
        expandFunction={setProductExpand}
      />
      <TableCollapsableHeaders
        data-testid="table-collapsable-headers-technical_features"
        title={t("cartesian.ui.axis_selection.technical_features")}
        length={technicalFeatureLength}
        updateFunction={setTechnicalFeatureLength}
        defaultValue={TechnicalFeaturesTableHeaders.length}
        expand={technicalFeatureExpand}
        expandFunction={setTechnicalFeatureExpand}
      />
      <TableCollapsableHeaders
        data-testid="table-collapsable-headers-performance_overview"
        title={t("cartesian.ui.axis_selection.performance_overview")}
        length={performanceOverviewLength}
        updateFunction={setPerformanceOverviewLength}
        defaultValue={PerformanceOverviewTableHeaders.length}
        expand={performanceOverviewExpand}
        expandFunction={setPerformanceOverviewExpand}
      />
      <TableCollapsableHeaders
        data-testid="table-collapsable-headers-guiding_system"
        title={t("cartesian.ui.axis_selection.guiding_system")}
        length={guidingSystemLength}
        updateFunction={setGuidingSystemLength}
        defaultValue={GuidingSystemTableHeaders(mechanics.quantityCarriages).length}
        expand={guidingSystemExpand}
        expandFunction={setGuidingSystemExpand}
      />
    </tr>
  );
};

const TableHeadersSection = ({
  productExpand,
  technicalFeatureExpand,
  performanceOverviewExpand,
  guidingSystemExpand
}) => {
  const mechanics = useSelector(selectMechanics);
  const renderHeaders = (headers, isExpanded) =>
    headers
      .map((header, index) => (
        <TableHeader
          data-testid={`table-header-${header.name}`}
          key={header.name}
          title={header.name}
          colNumber={index + 1}
          isSort={header.sort}
          hasUnitHeader
          unit={header.unit}
          headers={headers}
          subHeaders={header.subHeaders}
        />
      ))
      .filter((_, index) => isExpanded || index === 0); // Only render the first header if collapsed
  return (
    <tr className="TableHeadersSection">
      <TableHeader
        data-testid="table-header-product"
        title={t("cartesian.ui.axis_selection.product")}
        colNumber={0}
        isSort
      />
      {renderHeaders(ProductTableHeaders, productExpand)}
      {renderHeaders(TechnicalFeaturesTableHeaders, technicalFeatureExpand)}
      {renderHeaders(PerformanceOverviewTableHeaders, performanceOverviewExpand)}
      {renderHeaders(GuidingSystemTableHeaders(mechanics.quantityCarriages), guidingSystemExpand)}
      <TableHeader
        data-testid="table-header-select"
        title={t("cartesian.ui.axis_selection.select")}
        colNumber={
          ProductTableHeaders.length +
          TechnicalFeaturesTableHeaders.length +
          PerformanceOverviewTableHeaders.length +
          GuidingSystemTableHeaders(mechanics.quantityCarriages).length +
          1
        }
      />
    </tr>
  );
};

const getValueFromPath = (data, valuePath) => {
  if (valuePath.includes("?") && valuePath.includes(":")) {
    // Split the valuePath by the conditional operator
    const [condition, truePath, falsePath] = valuePath.split(/[?:]/);
    const path = eval(condition) ? truePath : falsePath;
    return path;
  }
  return valuePath;
};

function getTableContent(style, data, headers, contentLength) {
  const tableContent = headers
    .map((header, index) => {
      if (index >= contentLength) {
        return null; // Skip rendering if index exceeds contentLength
      }
      if (header.subHeaders) {
        // Handle subHeaders by grouping them in a single <td>
        const subHeaderValues = header.subHeaders.map((subHeader) => {
          const value = getValueFromPath(data, subHeader.valuePath)
            ?.split(".")
            ?.reduce((acc, part) => {
              if (part.endsWith("]")) {
                const index = parseInt(part.slice(0, -1).split("[")[1]);
                return acc[part.split("[")[0]][index];
              } else {
                return acc[part];
              }
            }, data);
          return value || "-";
        });
        return (
          <td key={header.name} className={style}>
            <div className="flex">
              {subHeaderValues.map((subHeaderValue, subIndex) => (
                <div key={subIndex} className="flex-1 px-4">
                  {subHeaderValue || "-"}
                </div>
              ))}
            </div>
          </td>
        );
      }

      // Handle Utilization mechanical drive torque & Utilization Utilization Speed
      if (header.name.includes("Utilization")) {
        const value = header.valuePath.split(".").reduce((acc, part) => acc && acc[part], data);
        return (
          <td className={style}>
            <ProgressBar percentage={value} />
          </td>
        );
      }

      // Handle regular headers
      const value = header.valuePath.split(".").reduce((acc, part) => acc && acc[part], data);
      return (
        <td key={header.name} className={style}>
          {value || "-"}
        </td>
      );
    })
    .filter(Boolean); // Filter out null values

  return tableContent;
}

const ProductRowToolTip = ({ description, data, showTooltip }) => {
  return (
    <div data-tip data-testid="product-row-tool-tip" className="ProductRowToolTip cursor-pointer flex" tabIndex={-1}>
      <MsxIcons name="info" className="text-gray-500" size="nano" />
      {showTooltip && (
        <ReactTooltip
          place="right"
          effect="solid"
          backgroundColor="#FFFFFF"
          textColor="rgb(31 41 55)"
          className="shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
        >
          <div className="flex flex-row">
            <div className="flex-col mr-1">
              {/* <img src={singleAxis} alt="linearAxis" className="max-h-[150px] max-w-[150px] w-35 h-35" /> */}
              <img src={getProductImgUrl(data?.axis?.axisGCR, 150, 150)} alt="Axis" />
            </div>
            <div className="flex flex-col mt-2">
              <div className="font-semibold text-blue-500">{description.name}</div>
              <div className="flex flex-row">
                <div className="mr-3">{t("cartesian.ui.axis_selection.profile_size")}:</div>
                <div className="font-semibold">{data?.axis?.profileDimension ? data?.axis?.profileDimension : "-"}</div>
              </div>
              <div className="flex flex-row">
                <div className="mr-3">{t("msizer.ui.drive_filters.drive_type")}:</div>
                <div className="font-semibold">{data?.axis?.driveType ? data?.axis?.driveType : "-"}</div>
              </div>
              <div className="flex flex-row">
                <div className="mr-3">Feed:</div>
                <div className="font-semibold">{data?.axis?.feedConstant ? data?.axis?.feedConstant : "-"}</div>
              </div>
              <div className="flex flex-row">
                <div className="mr-3">{t("cartesian.ui.axis_selection.repeatability")}:</div>
                <div className="font-semibold">{data?.axis?.repeatability ? data?.axis?.repeatability : "-"}</div>
              </div>
            </div>
          </div>
        </ReactTooltip>
      )}
    </div>
  );
};

const TableRowSection = ({
  isTopRow,
  isBorder,
  rowSpan,
  product,
  data,
  productLength,
  technicalFeatureLength,
  performanceOverviewLength,
  guidingSystemLength,
  selected
}) => {
  const style = `whitespace-nowrap text-center bg-whitee px-2 py-3 text-sm ${
    isBorder ? "border-b-2 border-gray-200" : ""
  }`;
  const mechanics = useSelector(selectMechanics);
  const productContent = getTableContent(style, data, ProductTableHeaders, productLength);
  const technicalFeatureContent = getTableContent(style, data, TechnicalFeaturesTableHeaders, technicalFeatureLength);
  const performanceOverviewContent = getTableContent(
    style,
    data,
    PerformanceOverviewTableHeaders,
    performanceOverviewLength
  );
  const guidingSystemContent = getTableContent(
    style,
    data,
    GuidingSystemTableHeaders(mechanics.quantityCarriages),
    guidingSystemLength
  );

  const axesToCompare = useSelector(selectAxesToCompare);
  const dispatch = useDispatch();
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <tr
      className={`TableRowSection group hover:outline-2 hover:outline-dashed hover:outline-gray-300 text-sm cursor-pointer
        ${selected ? "outline-1 outline-dashed outline-gray-300 bg-gray-100" : ""}
      `}
      onClick={() => {
        console.log("click on row", "product: ", product, "data :", data);
        const axis = { ...data, product };
        dispatch(addAxisToCompare({ axis }));
      }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {isTopRow && (
        <td rowSpan={rowSpan} className="border-b-2 border-l-2 border-gray-200 bg-gray-100 sticky left-0 px-1">
          <div className="flex justify-center items-center space-x-1">
            <div className="text-center font-semibold w-min">{product}</div>
            <ProductRowToolTip description="temp" data={data} showTooltip={showTooltip} />
          </div>
        </td>
      )}
      {productContent}
      {technicalFeatureContent}
      {performanceOverviewContent}
      {guidingSystemContent}
      <td className={`sticky right-0 !bg-gray-100 ${style} `}>
        <input
          type="checkbox"
          className="bg-white checked:bg-secondary cursor-pointer rounded-sm border-gray-400 checked:border-secondary"
          readOnly
          checked={axesToCompare?.some((axis) => axis.id === data.id)}
        />
      </td>
    </tr>
  );
};

const TableRowsSection = ({
  products, // This an object with keys as axisGCR
  productLength,
  technicalFeatureLength,
  performanceOverviewLength,
  guidingSystemLength
}) => {
  const selectedAxis = useSelector(selectSelectedAxis);
  const content = [];
  // Iterate over each group of products
  Object.keys(products).forEach((axisGCR) => {
    const productItems = products[axisGCR]; // Array of products for this axisGCR
    productItems.forEach((product, index) => {
      content.push(
        <TableRowSection
          data-testid={`table-row-section-${product.id}`}
          key={product.id} // Use a unique key for each row
          isTopRow={index === 0}
          isBorder={index === productItems.length - 1}
          rowSpan={productItems.length}
          product={product.axis.axisModel} // Use axisGCR as the product name
          data={product} // Pass the entire product as data
          productLength={productLength}
          technicalFeatureLength={technicalFeatureLength}
          performanceOverviewLength={performanceOverviewLength}
          guidingSystemLength={guidingSystemLength}
          selected={selectedAxis?.id === product.id}
        />
      );
    });
  });

  return content;
};

const TableSection = ({ axesCombinations, isLoadingOrFetching, countOfResults, paging, setPaging }) => {
  const mechanics = useSelector(selectMechanics);
  const [productLength, setProductLength] = useState(ProductTableHeaders.length);
  const [productExpand, setProductExpand] = useState(true);
  const [technicalFeatureLength, setTechnicalFeatureLength] = useState(1);
  const [technicalFeatureExpand, setTechnicalFeatureExpand] = useState(false);
  const [performanceOverviewLength, setPerformanceOverviewLength] = useState(PerformanceOverviewTableHeaders.length);
  const [performanceOverviewExpand, setPerformanceOverviewExpand] = useState(true);
  const [guidingSystemLength, setGuidingSystemLength] = useState(mechanics.quantityCarriages);
  const [guidingSystemExpand, setGuidingSystemExpand] = useState(true);

  return (
    <>
      <table cellSpacing={0} className="TableSection border-separate min-w-full mb-2">
        <thead>
          <TableCollapsableHeadersSection
            data-testid="table-collapsable-headers-section"
            productLength={productLength}
            setProductLength={setProductLength}
            productExpand={productExpand}
            setProductExpand={setProductExpand}
            technicalFeatureLength={technicalFeatureLength}
            setTechnicalFeatureLength={setTechnicalFeatureLength}
            technicalFeatureExpand={technicalFeatureExpand}
            setTechnicalFeatureExpand={setTechnicalFeatureExpand}
            performanceOverviewLength={performanceOverviewLength}
            setPerformanceOverviewLength={setPerformanceOverviewLength}
            performanceOverviewExpand={performanceOverviewExpand}
            setPerformanceOverviewExpand={setPerformanceOverviewExpand}
            guidingSystemLength={guidingSystemLength}
            setGuidingSystemLength={setGuidingSystemLength}
            guidingSystemExpand={guidingSystemExpand}
            setGuidingSystemExpand={setGuidingSystemExpand}
          />
          <TableHeadersSection
            data-testid="table-headers-section"
            productExpand={productExpand}
            technicalFeatureExpand={technicalFeatureExpand}
            performanceOverviewExpand={performanceOverviewExpand}
            guidingSystemExpand={guidingSystemExpand}
          />
        </thead>

        <tbody className="border-b border-solid border-gray-200 " key="tbody">
          {axesCombinations && !isLoadingOrFetching && (
            <TableRowsSection
              data-testid="table-rows-section"
              products={axesCombinations}
              productLength={productLength}
              technicalFeatureLength={technicalFeatureLength}
              performandeOverviewLength={performanceOverviewLength}
              guidingSystemLength={guidingSystemLength}
            />
          )}
        </tbody>
      </table>
      {isLoadingOrFetching && <TableSkeleton />}
      <Pagination
        paging={paging}
        setPaging={setPaging}
        countOfResults={countOfResults}
        showPagination={!isLoadingOrFetching}
      />
      {!isLoadingOrFetching && axesCombinations && countOfResults === 0 && (
        <div className="flex justify-center">
          <div className="border-2 border-warningLevelRed w-fit p-1 font-bold mb-3">
            {t("cartesian.ui.axis_selection.zero_results")}
          </div>
        </div>
      )}
    </>
  );
};

const contentStyle = {
  width: "97%"
};

const AxisComparatorSelection = () => {
  // const [showAxis, setShowAxis] = useState(true);
  const compareDatas = useSelector(selectAxesToCompare);
  const mechanics = useSelector(selectMechanics);
  return (
    <>
      <div className="AxisComparatorSelection">
        {/* <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_options.axis")}
          isSectionHeader
          opened={showAxis}
          values={compareDatas.map((bundle) => bundle.name)}
          onClick={() => setShowAxis(!showAxis)}
        />
        {showAxis && (
          <> */}
        <ComparatorLine
          compareData={compareDatas}
          isProductImages
          values={compareDatas.map((bundle) => bundle.axis?.axisGCR)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.product_model")}
          values={compareDatas.map((bundle) => bundle.axis?.axisModel)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.axis_description")}
          values={compareDatas.map((bundle) => bundle.axis?.mediumDescription)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.axis_profile_width_x_height")}
          values={compareDatas.map((bundle) => bundle.axis?.profileDimension)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.axis_profile_with_carriage_width_x_height")}
          values={compareDatas.map((bundle) => bundle.axis?.axisDimension)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.mechanical_drive_element")}
          values={compareDatas.map((bundle) => bundle.axis?.driveType)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.guide_type")}
          values={compareDatas.map((bundle) => bundle.guideType?.guideType)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.feed_constant")}
          values={compareDatas.map((bundle) => bundle.axis?.feedConstant)}
          unit="mm/rev"
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.carriage_type")}
          values={compareDatas.map((bundle) => bundle.carriageType?.typeOfCarriage)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.carriage_length")}
          values={compareDatas.map((bundle) => bundle.carriageType?.lenghtCommercialReference)}
          unit="mm"
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.distance_between_two_carriages")}
          values={compareDatas.map(() => mechanics?.distanceBetweenCarriages)}
          unit="mm"
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.quantity_of_ball_screw_supports")}
          values={compareDatas.map((bundle) =>
            bundle.calculations?.totalAxisLengthPreCalculations?.preCalcLengthBallScrew.toFixed(0)
          )}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.distance_between_double_axes")}
          values={compareDatas.map(() => "")}
          unit="mm"
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.total_axis_length")}
          values={compareDatas.map((bundle) => bundle.calculations?.axisLength)}
          unit="mm"
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.total_axis_weight")}
          values={compareDatas.map((bundle) => bundle.calculations?.axisWeight)}
          unit="kg"
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.repeatability")}
          values={compareDatas.map((bundle) => bundle.axis?.repeatability)}
          unit="mm"
        />
      </div>
      {/* </> */}
      {/* )} */}
    </>
  );
};

const PerformanceComparatorSelection = () => {
  const [showPerformance, setPerformance] = useState(true);
  const compareDatas = useSelector(selectAxesToCompare);
  return (
    <>
      <ComparatorLine
        compareData={compareDatas}
        title={t("cartesian.ui.axis_selection.performance_indicators")}
        isSectionHeader
        opened={showPerformance}
        values={compareDatas.map(() => "")}
        onClick={() => setPerformance(!showPerformance)}
      />
      {showPerformance && (
        <>
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.axis_performance")}
            values={compareDatas.map((bundle) => (
              <AxisPerformance position={bundle.position} data-testid="axis-performance" />
            ))}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.price_indicator")}
            values={compareDatas.map((bundle) => bundle.priceIndicator)}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.service_life_guide")}
            values={compareDatas.map((bundle) => bundle.guideSystem)}
          />
        </>
      )}
    </>
  );
};

const MechanicalComparatorSelection = () => {
  const [showMechanical, setMechanical] = useState(true);
  const compareDatas = useSelector(selectAxesToCompare);
  return (
    <div className="MechanicalComparatorSelection">
      <ComparatorLine
        compareData={compareDatas}
        title={t("cartesian.ui.axis_selection.mechanical_values")}
        isSectionHeader
        opened={showMechanical}
        values={compareDatas.map(() => "")}
        onClick={() => setMechanical(!showMechanical)}
      />
      {showMechanical && (
        <>
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.stroke")}
            values={compareDatas.map((bundle) => (
              <ProgressBar percentage={bundle.calculations?.strokeUtilization} />
            ))}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.speed")}
            values={compareDatas.map((bundle) => (
              <ProgressBar percentage={bundle.calculations?.speedAxisUtilization} />
            ))}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.acceleration")}
            values={compareDatas.map((bundle) => (
              <ProgressBar percentage={bundle.calculations?.speedAxisUtilization} />
            ))}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.force_fx")}
            values={compareDatas.map((bundle) => (
              <ProgressBar percentage={bundle.calculations?.forceFxUtilization} />
            ))}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.drive_torque")}
            values={compareDatas.map((bundle) => (
              <ProgressBar percentage={bundle.calculations?.driveTorqueUtilization} />
            ))}
          />
        </>
      )}
    </div>
  );
};

const CompareSection = ({ onClose, onSelect, onRemoveSolutionFromCompare }) => {
  const dispatch = useDispatch();
  const compareDatas = useSelector(selectAxesToCompare);
  return (
    <Popup
      data-testid="compare-section-popup"
      open
      modal
      contentStyle={contentStyle}
      closeOnDocumentClick={false}
      closeOnEscape={false}
    >
      {() => (
        <div className="CompareSection modal max-h-screen overflow-y-auto">
          <div>
            <div className="flex justify-end items-end">
              <AiFillCloseCircle className="text-lg text-gray-400 cursor-pointer close-modal-btn" onClick={onClose} />
            </div>
            <span className="text-gray-500 font-semibold text-base">
              <div className="md:border-[1px] md:border-solid md:border-gray-100 md:shadow-lg text-gray-600 flex flex-col space-y-5 py-4">
                <div className="mx-5 flex justify-between items-center">
                  <span className="font-bold">{t("msizer.ui.compare")}</span>
                  <Button
                    id="compare-button-clear"
                    textColor="blue"
                    disabled={compareDatas.length === 0}
                    onClick={() => {
                      dispatch(resetAxesToCompare());
                      onClose();
                    }}
                  >
                    <RiDeleteBinLine />
                    <span>{t("msizer.ui.compare.clear_all")}</span>
                  </Button>
                </div>

                <div className="text-xs">
                  <ComparatorLine
                    compareData={compareDatas}
                    type="header"
                    title={t("msizer.ui.compare.select_axis")}
                    headerBundles={compareDatas}
                    onSelect={onSelect}
                    onRemoveSolutionFromCompare={onRemoveSolutionFromCompare}
                  />
                  <AxisComparatorSelection data-testid="axis-comparator-selection" />
                  {/* <PerformanceComparatorSelection data-testid="performance-comparator-selection" />*/}
                  <MechanicalComparatorSelection data-testid="mechanical-comparator-selection" />
                  <ComparatorLine
                    compareData={compareDatas}
                    type="footer"
                    title={t("msizer.ui.compare.select_axis")}
                    headerBundles={compareDatas}
                    onSelect={onSelect}
                  />
                </div>
              </div>
            </span>
          </div>
        </div>
      )}
    </Popup>
  );
};

const AxisSelection = () => {
  const filters = useSelector(selectCartesianFilters);
  const [showCompare, setShowCompare] = useState(false);
  const axesToCompare = useSelector(selectAxesToCompare);
  const axisSelection = useSelector(selectAxisSelection);
  const selectedAxis = useSelector(selectSelectedAxis);
  const steps = useSelector(selectCartesianSteps);
  const mechanics = useSelector(selectMechanics);
  const dynamics = useSelector(selectDynamics);
  const axesCombinations = useSelector(selectAxesCombinations);
  const INIT_PAGING = {
    skip: 0,
    limit: 30
  };
  const [paging, setPaging] = useState(INIT_PAGING);
  const isReadOnly = useSelector(selectCartesianReadOnlyMode);
  const dispatch = useDispatch();

  const handleContinue = () => {
    if (axisSelection.isValid || axesToCompare?.length === 1) {
      onSelectAxis(axesToCompare[0]);
    } else {
      dispatch(
        showSnackbar({
          id: "MISSING_OR_INCORRECT_FIELD"
        })
      );
    }
  };

  const handlePrevious = () => {
    dispatch(setCartesianCurrentStep(steps.DYNAMICS));
    dispatch(updateConfiguration());
  };

  const groupByAxisGCR = (axisCombinations) => {
    return axisCombinations.reduce((acc, current) => {
      const { axisGCR } = current.axis;
      if (!acc[axisGCR]) {
        acc[axisGCR] = [];
      }
      acc[axisGCR].push(current);
      return acc;
    }, {});
  };

  const onSelectAxis = (axis) => {
    let axisChanged = false;
    if (axisSelection?.selectedAxis?.id !== axis.id) {
      axisChanged = true;
      dispatch(setAxisOptions(DEFAULT_AXIS_OPTIONS));
    }
    dispatch(
      setAxisSelection({
        ...axisSelection,
        selectedAxis: axis,
        isValid: true
      })
    );
    dispatch(setAxesToCompare([axis]));
    setShowCompare(false);
    dispatch(updateConfiguration());
    // go to the next step
    if (!isReadOnly || !axisChanged) {
      dispatch(setCartesianCurrentStep(steps.AXIS_OPTIONS));
    }
  };

  const handleRemoveSolutionFromCompare = (axis) => {
    var axesToCompareTmp = [...axesToCompare];
    axesToCompareTmp = axesToCompareTmp.filter((a) => a.id !== axis.id);
    if (axesToCompareTmp.length <= 1) {
      setShowCompare(false);
    }
    dispatch(setAxesToCompare(axesToCompareTmp));
  };

  if (!axesCombinations && axisSelection.selectedAxis) {
    const axisGroupByAxisGCR = groupByAxisGCR([axisSelection.selectedAxis]);
    dispatch(setAxesCombinations({ countOfResults: 1, axes: axisGroupByAxisGCR }));
  }

  const {
    isLoading: isLoadingGetAxesCombinations,
    isFetching: isFetchingGetAxesCombinations,
    refetch: fetchAxesCombinations
  } = useQuery(
    "Get axes combinations",
    async () => {
      try {
        const result = await getAxesCombinations({
          locale: "en-WW",
          paging,
          search: filters,
          mechanics: mechanics || {},
          dynamics: dynamics || {},
          order: {}
        });
        const groupedResults = groupByAxisGCR(result?.axisCombinationsFiltered);
        dispatch(setAxesCombinations({ countOfResults: result?.countOfResults, axes: groupedResults }));
        return groupedResults;
      } catch (error) {
        console.error("ERR", error);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  useEffect(() => {
    fetchAxesCombinations();
  }, [paging]);

  useEffect(() => {
    if (selectedAxis && axesToCompare.length === 0) {
      dispatch(setAxesToCompare([selectedAxis]));
    }
  }, []);

  return (
    <div className="AxisSelection space-y-3">
      <div className="flex flex-col w-full bg-white z-50">
        <MechanicsSummary data-testid="mechanics-summary" />
        <AxisSelectionFilter
          refetchAxesCombinations={() => {
            setPaging(INIT_PAGING);
          }}
          isLoadingOrFetchingGetAxesCombinations={isLoadingGetAxesCombinations || isFetchingGetAxesCombinations}
        />
      </div>
      <div className="flex flex-col bg-white">
        {axesCombinations && (
          <ScrollContainer hideScrollbars={false}>
            <TableSection
              data-testid="table-section"
              axesCombinations={axesCombinations.axes}
              isLoadingOrFetching={isLoadingGetAxesCombinations || isFetchingGetAxesCombinations}
              countOfResults={axesCombinations.countOfResults}
              paging={paging}
              setPaging={setPaging}
            />
          </ScrollContainer>
        )}
        {showCompare && (
          <CompareSection
            data-testid="compare-section"
            onClose={() => setShowCompare(false)}
            onSelect={(axis) => {
              onSelectAxis(axis);
            }}
            onRemoveSolutionFromCompare={(axis) => {
              handleRemoveSolutionFromCompare(axis);
            }}
          />
        )}
      </div>
      <Navigator
        continueLabel={
          axesToCompare?.length > 1
            ? tr("msizer.ui.compare.compare_n_axes", { n: axesToCompare?.length })
            : t("msizer.ui.compare.select_axis")
        }
        continueAction={() => {
          if (axesToCompare?.length === 1) {
            handleContinue();
          } else {
            setShowCompare(true);
          }
        }}
        continueButtonDisabled={axesToCompare?.length === 0 && !axisSelection.isValid}
        previousAction={() => {
          handlePrevious();
        }}
      />
    </div>
  );
};
export default AxisSelection;
